import { render, staticRenderFns } from "./ActividadesEconomicas.view.vue?vue&type=template&id=3d7314a2"
import script from "./ActividadesEconomicas.view.vue?vue&type=script&lang=js"
export * from "./ActividadesEconomicas.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports